import { render, staticRenderFns } from "./BanDialog.vue?vue&type=template&id=4c296106&"
import script from "./BanDialog.vue?vue&type=script&lang=js&"
export * from "./BanDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports